import jwtDecode from 'jwt-decode'
import { makeVar, useReactiveVar } from '@apollo/client'
import * as React from 'react'

import isExpired from '@/utils/jwt/is-expired'
import { getLocalStorage, setLocalStorage } from '@/utils/browser/localstorage'
import { LocalStorageEnum } from '@/constants/localstorage'

export const authTokenStore = makeVar({ token: '', userId: '' })

export const getJwtPayload = (token: string) =>
  token && !isExpired(token) ? jwtDecode<AuthTokenPayload>(token) : null

export const getUserIdByToken = (token: string) => {
  const jwtPayload = getJwtPayload(token)
  return jwtPayload && jwtPayload.data?.user_id ? `${jwtPayload.data.user_id}` : ''
}

const setAuthTokenStore = (token: string) => {
  authTokenStore({ token, userId: getUserIdByToken(token) })
}

type AuthTokenPayload = {
  data: {
    nickname: string
    user_id: number
  }
  exp: number
  iat: number
  iss: string
}

export const getAuthToken = () => {
  return getLocalStorage<string>({ key: LocalStorageEnum.AuthToken })
}

export const useAuthTokenStore = () => {
  const { token, userId } = useReactiveVar(authTokenStore)

  React.useEffect(() => {
    if (!token) {
      setAuthTokenStore(getAuthToken())
    }
  }, [token])

  return { token, userId }
}

export const setAuthToken = (newToken = '') => {
  setLocalStorage<string>({ key: LocalStorageEnum.AuthToken, value: newToken })
  setAuthTokenStore(newToken ?? '')
}
